import React from 'react'
import styled from '@emotion/styled'

import { fontSize3XSmall, fontFamilyOpenSans, highlightBlueBase } from '../../constants/principles'
import { breakpoints } from '../../constants'

export default ({ isDesktop, dealerIsDirectToKBBv2, kbbUrl = 'https://www.kbb.com', isLandingPage = false }) => (
  <StyledDiv data-testid={`ci-legal-text`} isDesktop={isDesktop} directToKBBv2={dealerIsDirectToKBBv2} isLandingPage={isLandingPage} data-nosnippet>
    {dealerIsDirectToKBBv2
      ? `This program involves selling directly to a Kelley Blue Book affiliate. Location restrictions apply. 
    Not all vehicles are eligible. The Offer amount may be less than the Kelley Blue Book® Trade-In Value or Range. 
    An inspection is required, and if the info you provide about the vehicle differs from the inspection, the Offer amount may be decreased.`
      : `Not all vehicles are eligible for an Instant Cash Offer. The Offer may be less than the Kelley Blue Book® Trade-In Value or Range. Kelley Blue Book does not redeem Offers, purchase vehicles or own/operate Participating Dealers. Dealer inspection
    required. If the info you provide about the vehicle differs from the dealer inspection, the Offer amount may be decreased. Kelley Blue Book and its affiliates are not responsible for Offer adjustments or if a Participating Dealer won’t accept your
    vehicle. Dealers pay a fee to participate in the Kelley Blue Book Instant Cash Offer program. `}
    <StyledA data-testid={'bi-btn-term-and-contitions'} target="_blank" href={`${kbbUrl}/company/terms-of-service/#termsAndConditions`}>
      Program Terms and Conditions
    </StyledA>
    {' apply.'}
  </StyledDiv>
)

const StyledA = styled.a`
  color: ${highlightBlueBase};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`

const StyledDiv = styled.div`
  font-size: ${fontSize3XSmall};
  font-family: ${fontFamilyOpenSans};
  line-height: 17px;
  text-align: justify;
  @media (min-width: ${breakpoints.lg}px) {
    width: 800px;
  }
  margin: ${p => (p.directToKBBv2 && p.isLandingPage ? 0 : 40)}px 16px ${p => (p.directToKBBv2 && p.isLandingPage ? 90 : 16)}px 16px;
`
